webpackJsonp([145822418891640],{

/***/ 3276:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/complete-review-for-brian-flatts-2-week-diet-07-14-2018"},"frontmatter":{"title":"Complete Review For Brian Flatts 2 Week Diet","date":"2018-07-14"}}}]}},"pathContext":{"tag":"how to burn fat fast"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-how-to-burn-fat-fast-a7632a384a483b2d06fc.js